import { appConfig as $config } from '../../app.config';
import { App } from '../App';
import { UI } from '../UI';
import { ColorVariants } from '../ColorVariants';
import { MockupStatus } from '../ReactComponent';
import { Common } from '../Common';
import { ApprovalRejection } from '../ApprovalRejection';

import './scss/productinfo.scss';
import { User } from '../User';

export const ProductInfo = (function () {
  let $params;
  let $choosenPanelColor, $choosenPanel;
  let $isLicensor = '';

  let mapping = {
    data: (data) => {
      let frames = [];
      $.each(data.variants, function (k, v) {
        if (!v.approved) return;
        $.each(v.frameImages, function (k, f) {
          let frame = _.findWhere(frames, { areaType: f.areaType });
          let areaImage = { imageFileUrl: f.imageFileUrl, color: v.color };
          if (!frame) {
            frame = { areaType: f.areaType, images: [areaImage], firstImage: f.imageFileUrl };
            frames.push(frame);
          } else {
            frame.images.push(areaImage);
          }
        });
      });
      data.masterProductData.commerce.agentRoyalty = data.masterProductData.commerce.agentRoyalty || 0;
      data.masterProductData.commerce.licenseeRoyalty = data.masterProductData.commerce.licenseeRoyalty || 0;
      data.masterProductData.commerce.licensorRoyalty = data.masterProductData.commerce.licensorRoyalty || 0;

      let productInStores = '';
      if (data.productInStores.length) {
        productInStores = data.productInStores
          .map((store) => {
            return store.productUrl
              ? `<a href="${store.productUrl}" target="_blank">${store.storeDisplayName || store.storeName}</a>`
              : store.storeDisplayName || store.storeName;
          })
          .join(', ');
      } else if (data.masterProductData.storesWithLanguages.length) {
        productInStores = data.masterProductData.storesWithLanguages
          .map((store) => {
            return `${store.storeDisplayName || store.storeName} (${store.languageCodes.toString().toUpperCase()})`;
          })
          .join(', ');
      }
      /*let productInStores = data.masterProductData.storesWithLanguages && $.map(data.masterProductData.storesWithLanguages, stwl => { return { storeName: stwl.storeDisplayName, langCodes: stwl.languageCodes.toString().toUpperCase() } });
      let productInStoresString = data.productInStores.map(store => {
                  return store.productUrl ? `<a href="${store.productUrl}" target="_blank">${store.storeDisplayName || store.storeName}</a>` : store.storeDisplayName || store.storeName
                }).join(', ');*/

      return {
        ...data,
        ...{
          // Approval Item mapping
          approveItem: Common.mapping.approvalObject(data.approveItem),
          account: data.accountName,
          image: data.thumbnailImageUri,
          createdDate: moment(data.createdDate).format($config.appFullDateFormat),
          brand: data.masterProductData.brand,
          subbrand: data.masterProductData.subBrand,
          description: data.masterProductData.productDescription,
          tags: data.masterProductData.tags,
          frames: frames,
          productInStores: productInStores,
          blankSizes: Common.sizeRange(data.availableSizes),
          commerce: data.masterProductData.commerce,
          skuPrefix: data.masterProductData.skuPrefix,
          bullets: data.masterProductData.bulletPoints
        }
      };
    }
  };

  let dialog = (id, params = {}) => {
    if (!id) return;
    UI.blockPage();
    $params = params;
    $isLicensor = User.isLicensor();
    let onEscape = params.onClose ? params.onClose : () => {};
    $choosenPanel = null;
    $choosenPanelColor = null;

    
    $.when(App.ajaxData(`${params.pageUrl ? params.pageUrl : 'LicensedProducts'}/${params.accountId}/${id}`)).done(
      (res) => {
        let data = {
          $lang: $Lang,
          product: mapping.data(res.object),
          params: params,
          choosenPanel: $choosenPanel,
          isLicensor: $isLicensor,
        };


      App.pageData('product_info', data.product);


      let template = require('./tmpl/dialog.hbs');
      bootbox
        .dialog({
          title: $lang.productinfo.ProductInformation,
          message: template(data),
          size: 'xl',
          className: 'modal-scrolled-content modal-product-information',
          onEscape: onEscape
        })
        .init(() => {
          init(data);
        });
    });
  };

  let init = (data) => {
    UI.unblockPage();
    let wrap = $('.product-information-content');

    if (data.params && data.params.pageUrl && data.params.buttons) {
      let buttons = data.params.buttons;
      if (buttons.submitBOM) {
        $('.js-action-submitbom', wrap)
          .prop('disabled', false)
          .on('click', (e) => {
            let target = $(e.target).hasClass('js-action-submitbom')
              ? $(e.target)
              : $(e.target).closest('.js-action-submitbom');
            let type = target.data('submittype');
            if (!type) return;
            buttons.submitBOM({ [data.product.id]: data.params.accountId }, type, 'dialog');
          });
      }
      if (buttons.bominfo) {
        $('.js-action-bominfo', wrap)
          .prop('disabled', false)
          .on('click', () => {
            const { title, standartId, accountId, submitStatusInformation, id } = data.product;
            const modalConfig = {
              title,
              standartId,
              id,
              accountId,
              apiUrl: $config.apiURL,
              createdDate: submitStatusInformation?.bomLastSuccessLogInformation?.createDate,
              requestId: id,
              urlPath: 'SKUCatalog/get-bom-files-by-product',
              requestPageType: 'MockupBomFolder',
              directoryName: 'BOM',
              isKSF: false
            };
            MockupStatus.init('mockupStatusModal', modalConfig);
          });
      }
      if (buttons.storeData) {
        $('.js-action-storeData', wrap)
          .prop('disabled', false)
          .on('click', () => {
            bootbox.hideAll();
            $router.push(`/${data.params.pageUrl}/${data.product.id}/masterProductData`);
          });
      }
      if (buttons.productionData) {
        $('.js-action-productionData', wrap)
          .prop('disabled', false)
          .on('click', () => {
            bootbox.hideAll();
            $router.push(`/${data.params.pageUrl}/${data.product.id}/masterProductData?tab=production`);
          });
      }
      if (buttons.customize) {
        $('.js-action-customize', wrap)
          .prop('disabled', false)
          .on('click', () => {
            bootbox.hideAll();
            $router.push(`/${data.params.pageUrl}/${data.product.id}/design-studio`);
          });
      }
      if (buttons.mockupComparison) {
        $('.js-action-mockupComparison', wrap)
          .prop('disabled', false)
          .on('click', () => {
            bootbox.hideAll();
            window.location.href = `${window.location.origin}/mockup-comparison`;
          });
      }
      if (buttons.sendApprove) {
        $('.js-action-sendApprove', wrap)
          .prop('disabled', false)
          .on('click', () => {
            bootbox.hideAll();
            buttons.sendApprove(`${data.product.id}`);
          });
      }
      if (buttons.sendSample) {
        $('.js-action-sendSample', wrap)
          .prop('disabled', false)
          .on('click', () => {
            bootbox.hideAll();
            buttons.sendSample(`${data.product.id}`);
          });
      }
      if (buttons.sendApproval) {
        $('.js-action-sendApproval', wrap)
          .prop('disabled', false)
          .on('click', () => {
            bootbox.hideAll();
            buttons.sendApproval(`${data.product.id}`);
          });
      }
      if (buttons.downloadApproval) {
        $('.js-action-downloadapproval', wrap)
          .prop('disabled', false)
          .on('click', () => {
            buttons.downloadApproval(`${data.product.id}`);
          });
      }
      if (buttons.delete) {
        $('.js-action-delete', wrap)
          .prop('disabled', false)
          .on('click', () => {
            buttons.delete(`${data.product.id}`);
          });
      }
      if (buttons.approveReject) {
        $('.js-action-approve-reject', wrap)
          .prop('disabled', false)
          .on('click', () => {
            ApprovalRejection.dialog({
              items: { [data.product.id]: data.product.accountId || User.accountID() },
              page: 'prelistings',
              callback: () => {
                reloadDialog(data.product.id, data.params);
              }
            });
          });
      }
    }

    $('.owl-carousel', wrap).owlCarousel({
      autoWidth: true,
      mouseDrag: false,
      dots: false,
      nav: true
    });

    $('.c-pic', wrap).on('click', function () {
      let thisimg = $(this).data('imguri');
      let parent = $(this).closest('.image-carousel');
      let bigimg = $(this).closest('.img-content').find('.img-bg-square');
      $('.active-image', parent).removeClass('active-image');
      $(this).addClass('active-image');
      bigimg.css({ backgroundImage: `url(${thisimg})` });

      $choosenPanelColor = $(this).data('imgcolor');
    });

    $('a[data-toggle="tab"]', wrap).on('shown.bs.tab', function (event) {
      // Set selected panel
      $choosenPanel = $(event.target).data('panelname') || null;
      setColorSelectedPanel();
    });

    setColorSelectedPanel();

    ColorVariants.init('#product-colors', {
      id: App.pageData('product_info').id,
      variants: App.pageData('product_info').variants.map((v) => {
        v.disabled = data.params.colorsDisabled || $isLicensor;
        return v;
      })
    }).then(() => {
      if (!data.params.colorsDisabled) {
        $('.modal-product-information input.item-color-checkbox').on('change', function () {
          let isUpdate = updateMockupColor(this.id, $(this).is(':checked'));
          if (!isUpdate) {
            $(this).prop('checked', true);
          }
        });
      }
    });
  };

  let updateMockupColor = (id, isChecked) => {
    const idsToParse = id.substring(6, id.length).split('$');

    let isUpdate = true;
    if (!idsToParse || idsToParse.length !== 2) {
      return false;
    }

    const mockupId = idsToParse[0];
    const colorName = idsToParse[1];

    let data = App.pageData('product_info');

    const payload = {
      id: mockupId,
      accountId: data.accountId,
      title: '_',
      blank: {
        id: null,
        title: '_'
      },
      productInStores: [],
      salesByStore: [],
      variants: [
        {
          color: colorName,
          approved: isChecked
        }
      ]
    };

    if (!isChecked) {
      isUpdate = data.variants.filter((f) => f.approved).length > 1;
    }

    if (!isUpdate) {
      return false;
    }

    UI.block('.modal-content');
    $.when(App.ajaxData('prelistings/selectColors', payload, 'POST')).done((res) => {
      if (!res.isSuccess) {
        UI.unblock('.modal-content');
        if (res.validationErrors) {
          if (res.validationErrors.length && res.validationErrors[0].errorType == 5) {
            UI.errorMultiMessage(res.validationErrors[0].details);
          }
        }
        $(`[id="${id}"]`).prop('checked', false);

        return;
      }
      reloadDialog(payload.id, $params);
    });

    return isUpdate;
  };

  let reloadDialog = (id, params) => {
    if (!id) return;

    UI.block('.modal-content');

    
    $.when(App.ajaxData(`${params.pageUrl ? params.pageUrl : 'LicensedProducts'}/${params.accountId}/${id}`)).done(
      (res) => {
        let data = {
          $lang: $Lang,
          product: mapping.data(res.object),
          params: params,
          choosenPanel: $choosenPanel
        };

        App.pageData('product_info', data.product);
        let template = require('./tmpl/dialog.hbs');

        UI.render('.modal-body .bootbox-body', template, data).then(() => {
          init(data);
          UI.unblock('.modal-content');
        });
      }
    );
  };

  let setColorSelectedPanel = () => {
    $('.tab-pane.active .c-pic').each(function () {
      if ($(this).data('imgcolor') == $choosenPanelColor) {
        $(this).click();
      }
    });
  };

  return {
    dialog,
    reloadDialog
  };
})();
